import { DatoCmsPdv } from 'lib/datoCms/queries/getAllPdvLabels';
import { DatoCmsSignUp } from 'lib/datoCms/queries/getAllSignUpLabels';
import { RegistrationUnCompletedLabel } from '../RegistrationUncompleted';

export const getRegistrationUncompletedLabel = (label: DatoCmsSignUp | DatoCmsPdv): RegistrationUnCompletedLabel => {
  return {
    title: label.titleRegistrationUncompleted,
    description: label.descriptionRegistrationUncompleted,
    buttonLabel: label.buttonTryAgain,
  };
};
